import { useLocation } from 'react-router-dom';

import { ProductSelectionPaths, useMatchLinks } from '@/shared/lib/react-router';

export const useProductSelectionLayoutTabs = () => {
  const [matchedLink] = useMatchLinks(
    ProductSelectionPaths.MANUAL_SELECTION_PATH,
    ProductSelectionPaths.SPECIAL_OFFERS_SELECTION_PATH,
    ProductSelectionPaths.BY_DISTRIBUTOR_PATH,
    ProductSelectionPaths.AUTO_SELECTION_PATH,
    ProductSelectionPaths.BEST_OFFERS_PATH,
    ProductSelectionPaths.BOUND_DRUGS_PATH,
  );

  const manualTabValue = ProductSelectionPaths.MANUAL_SELECTION_PATH;
  const specialOffersTabValue = ProductSelectionPaths.SPECIAL_OFFERS_SELECTION_PATH;
  const byDistributorTabValue = ProductSelectionPaths.BY_DISTRIBUTOR_PATH;
  const autoTabValue = ProductSelectionPaths.AUTO_SELECTION_PATH;
  const bestOffersTabValue = ProductSelectionPaths.BEST_OFFERS_PATH;
  const boundDrugsValue = ProductSelectionPaths.BOUND_DRUGS_PATH;

  const { pathname } = useLocation();

  const currentTab = matchedLink?.pathname ?? (pathname.startsWith(autoTabValue) ? autoTabValue : manualTabValue);
  const isManualTab = currentTab === manualTabValue;
  const isSpecialOffersTab = currentTab === specialOffersTabValue;
  const isByDistributorTab = currentTab === byDistributorTabValue;
  const isAutoTab = currentTab === autoTabValue;
  const isBestOffersTab = currentTab === bestOffersTabValue;
  return {
    isManualTab,
    isSpecialOffersTab,
    isByDistributorTab,
    isAutoTab,
    isBestOffersTab,
    currentTab,
    manualTabValue,
    specialOffersTabValue,
    byDistributorTabValue,
    autoTabValue,
    bestOffersTabValue,
    boundDrugsValue,
  };
};
